import {GetLifeplaceProductsParams} from 'domain/usecases/private/lifeplace/get-lifeplace-products';
import {makeGetLifeplaceProducts} from 'main/factories/usecases/private/lifeplace/get-lifeplace-products-factory';
import {formatPrice} from 'presentation/utils';

export async function getLifeplaceProducts(params: GetLifeplaceProductsParams) {
	const response = await makeGetLifeplaceProducts().get(params);

	const products = response?.Data?.map(product => ({
		name: product.ProductName,
		imageUrl: product.SkuImageUrl,
		position: product.Position,
		listPrice: product.ListPrice ? formatPrice(product.ListPrice / 100) : '',
		price: product.Price ? formatPrice(product.Price / 100) : 'R$ -',
		link: product.ProductLink,
		installment: product.Installment,
		installmentValue: product.InstallmentValue
			? formatPrice(product.InstallmentValue / 100)
			: '',
	})).sort((a, b) => a.position - b.position);

	return products;
}
